import 'react-app-polyfill/ie11';
import React from 'react';
import {Authenticator} from '@aws-amplify/ui-react';
import App from './App';
import {createRoot} from 'react-dom/client';
import {HashRouter} from 'react-router-dom'
import { Amplify } from 'aws-amplify';
import { fetchAuthSession } from 'aws-amplify/auth';
import { I18n } from "aws-amplify/utils";
import config from './config';
import {dictionaryLabels} from './dictionnary';
import {setAppLanguage} from './Utils';

let blng = 'fr';
if (navigator.language) {
    const lng = navigator.language;
    if (lng === "fr" || lng === "de") {
        blng = lng;
    }
}
setAppLanguage(blng);

I18n.putVocabularies(dictionaryLabels);

Amplify.configure({
    Auth: {
        Cognito: {
            region: config.cognito.REGION,
            userPoolId: config.cognito.USER_POOL_ID,
            userPoolClientId: config.cognito.APP_CLIENT_ID,
            identityPoolId: config.cognito.IDENTITY_POOL_ID,
            loginWith: { username: true },
            allowGuestAccess: false,
        }
    },
    Storage: {
        S3: {
            region: config.s3.REGION,
            bucket: config.s3.BUCKET,
        }
    },
    API: {
        REST: {
            "api-maitrise": {
                endpoint: config.apiGateway.URL_MAITRISE,
                region: config.apiGateway.REGION,
                headers: async () => {
                    const session = await fetchAuthSession();
                    const idToken = session.tokens?.idToken?.toString();
                    return { Authorization: `Bearer ${idToken}` };
                }
            }
        }
    }
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <React.StrictMode>
        <HashRouter>
            <Authenticator.Provider>
                <App />
            </Authenticator.Provider>
        </HashRouter>
    </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();
